import * as actions from './actions'
import * as getters from './getters'
import * as types from './types'

const state = {
  depositOrderFilterData: {
    activeTimeRange: 0,
    remark: '',
    startTime: '',
    endTime: '',
    orderStatus: 0,
    storeIds: [],
    cashierIds: [],
    payType: 0
  }
}
const mutations = {
  [types.SET_DEPOSIT_ORDER_FILTER_DATA] (state, data) {
    state.depositOrderFilterData = data
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
